import React from 'react';

import '@app/scss/components/middleText.scss';

interface MiddleTextProps {
	title?: string;
	subtitle?: string;
	text?: string | any;
	style?: any;
}

const MiddleText: React.FC<MiddleTextProps> = ({
	title,
	subtitle,
	text,
	children,
	style = null,
}) => (
	<article className="middle-text">
		{title && <h4 className="middle-text__title">{title}</h4>}
		{subtitle && <h5 className="middle-text__title middle-text__subtitle">{subtitle}</h5>}
		{text && <div className="middle-text__text" dangerouslySetInnerHTML={{ __html: text }} style={style} />}
		{children}
	</article>
);

export default MiddleText;
